// Chart component
export default function (data) {
    let root, canvas, spinnerContainer, timeoutId;

    data = typeof data === 'function' ? data() : data;

    const configureChartDefaults = () => {
        const bodyStyle = window.getComputedStyle(document.body);
        const fontSize = parseFloat(bodyStyle.fontSize);

        Chart.defaults.color = bodyStyle.color;

        Object.assign(Chart.defaults.font, {
            family: bodyStyle.fontFamily,
            size: Math.round(fontSize * 9) / 10,
        });

        Chart.defaults.scale.title.font = { size: fontSize };
        Chart.defaults.plugins.title.font.size = Math.round(fontSize * 11) / 10;
        Chart.defaults.plugins.tooltip.boxPadding = 2;

        window._chartDefaultsConfigured = true;
    };

    const component = {
        loaded: false,

        init() {
            if (!window._chartDefaultsConfigured) {
                configureChartDefaults();
            }

            root = this.$root;
            canvas = this.$refs.canvas;
            spinnerContainer = this.$refs.spinnerContainer;

            const transitionDuration = Math.round(parseFloat(window.getComputedStyle(root).transitionDuration) * 1e3);

            const checkLoaded = () => {
                if (timeoutId) {
                    window.clearTimeout(timeoutId);
                }

                if (this.loaded) {
                    canvas.classList.remove('opacity-25', 'pe-none');
                    spinnerContainer.classList.add('opacity-0');

                    timeoutId = window.setTimeout(
                        () =>
                            this.$nextTick(() => {
                                spinnerContainer.classList.add('d-none');
                                spinnerContainer.classList.remove('d-flex');
                            }),
                        transitionDuration
                    );
                } else {
                    canvas.classList.add('opacity-25', 'pe-none');
                    spinnerContainer.classList.add('d-flex');
                    spinnerContainer.classList.remove('opacity-0', 'd-none');
                }
            };

            this.$watch('loaded', checkLoaded);
            checkLoaded();
        },
    };

    return Helper.mergeAlpineComponents.apply(Helper, [component, data]);
}
